import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../../AuthContextWrapper";
import { Box, Button, Typography } from "@mui/material";

import primaryHome1 from "../../assets/primary-home-1x.png";
import primaryHome15 from "../../assets/primary-home-1.5x.png";
import primaryHome2 from "../../assets/primary-home-2x.png";
import primaryHome3 from "../../assets/primary-home-3x.png";

import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { OUTCOMES } from "../../../constants";
import { AssetContext } from "../../../AssetContextWrapper";

export const WelcomeScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, user, activeEstate } = useAuthContext()
  const { assetsLoaded } = useContext(AssetContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  useEffect(() => {
    // get assets loaded to make the address screen pre-pop more quickly
    console.log("assetsLoaded", assetsLoaded);
  }, []);

  const handleComplete = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper hideSectionHeading={true} centerContent={true}>
      <>
        <Box
          sx={{
            my: 2,
            textAlign: "center",
          }}
        >
          <img
            srcSet={`${primaryHome15} 1.5x, ${primaryHome2} 2x, ${primaryHome3} 3x`}
            src={primaryHome1}
            alt="Primary Home"
            title="Primary Home"
          />
        </Box>
        <Box
          sx={{
            my: 2,
            textAlign: "center",
          }}
        >
          <Typography component="h2" variant="h3">
            {user?.profile?.firstName}, we need some info about{" "}
            {activeEstate?.deceasedFirstName}'s home to determine what kind of
            Probate and Forms you’ll need
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            my: 6,
          }}
        >
          <Button
            variant="contained"
            onClick={() => handleComplete()}
            sx={{
              mb: 3,
            }}
          >
            Continue
          </Button>
        </Box>
      </>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
